exports.PROTOCOL = {
  en: {
    appointment: '//www.mechabreak.com/show-1034-38-1.html',
    cookie: '//www.mechabreak.com/show-1031-35-1.html',
    privacy: '//www.mechabreak.com/show-1031-29-1.html',
    service: '//www.mechabreak.com/show-1031-33-1.html'
  },
  ja: {
    appointment: '//www.mechabreak.com/show-1031-41-1.html',
    cookie: '//www.mechabreak.com/show-1031-36-1.html',
    privacy: '//www.mechabreak.com/show-1031-28-1.html',
    service: '//www.mechabreak.com/show-1031-32-1.html'
  },
  ko: {
    appointment: '//www.mechabreak.com/show-1031-40-1.html',
    cookie: '//www.mechabreak.com/show-1031-37-1.html',
    privacy: '//www.mechabreak.com/show-1031-27-1.html',
    service: '//www.mechabreak.com/show-1031-31-1.html'
  },
  'zh-Hant': {
    appointment: '//www.mechabreak.com/show-1031-39-1.html',
    cookie: '//www.mechabreak.com/show-1031-34-1.html',
    privacy: '//www.mechabreak.com/show-1031-26-1.html',
    service: '//www.mechabreak.com/show-1031-30-1.html'
  },
  es: {
    appointment: '//www.mechabreak.com/show-1094-146-1.html',
    cookie: '//www.mechabreak.com/show-1094-147-1.html',
    privacy: '//www.mechabreak.com/show-1094-148-1.html',
    service: '//www.mechabreak.com/show-1094-149-1.html'
  },
  pt: {
    appointment: '//www.mechabreak.com/show-1095-153-1.html',
    cookie: '//www.mechabreak.com/show-1095-152-1.html',
    privacy: '//www.mechabreak.com/show-1095-151-1.html',
    service: '//www.mechabreak.com/show-1095-150-1.html'
  },
  de: {
    appointment: '//www.mechabreak.com/show-1096-157-1.html',
    cookie: '//www.mechabreak.com/show-1096-156-1.html',
    privacy: '//www.mechabreak.com/show-1096-155-1.html',
    service: '//www.mechabreak.com/show-1096-154-1.html'
  },
  fr: {
    appointment: '//www.mechabreak.com/show-1097-161-1.html',
    cookie: '//www.mechabreak.com/show-1097-160-1.html',
    privacy: '//www.mechabreak.com/show-1097-159-1.html',
    service: '//www.mechabreak.com/show-1097-158-1.html'
  },
  ru: {
    appointment: '//www.mechabreak.com/show-1098-165-1.html',
    cookie: '//www.mechabreak.com/show-1098-164-1.html',
    privacy: '//www.mechabreak.com/show-1098-163-1.html',
    service: '//www.mechabreak.com/show-1098-162-1.html'
  }
};
